export default {
  lang: {
    selectAll: 'Halaman pemilihan penuh',
    selected: 'Telah dipilih',
    term: 'Strip',
    deselect: 'Batalkan pilihan',
  },
};
